module.exports = __webpack_public_path__ + "img/logo.8ea1178d.png";